import { pick, debounce } from "lodash";
import { UserSetting, UserSettingId } from "helpers/usersettings/UserSetting";
import { TicketSchedulingState } from "pages/tickets/scheduling/TicketSchedulingContext";

export type TicketSchedulingUserSettingsData = Pick<
  TicketSchedulingState,
  "selectedDate" | "driversSelected" | "division" | "warehouse"
>;

const TicketSchedulingSettings = (() => {
  const keys: (keyof TicketSchedulingState)[] = [
    "driversSelected",
    "divisionSelected",
    "warehouseSelected"
  ];
  const userSettingsActions = new UserSetting<TicketSchedulingUserSettingsData>(
    UserSettingId.TicketScheduling
  );

  const save = debounce(userSettingsActions.save, 200);

  function shouldSave(state: Partial<TicketSchedulingState>) {
    for (const key in state) {
      const shouldSave = keys.includes(key as keyof TicketSchedulingState);
      if (shouldSave) return true;
    }
    return false;
  }

  return {
    async onStateChange(
      partialState: Partial<TicketSchedulingState>,
      newState: TicketSchedulingState
    ) {
      if (!shouldSave(partialState)) return;

      let ticketSchedulingState = pick(newState, ...keys);

      ticketSchedulingState = {
        ...ticketSchedulingState,
        driversSelected: ticketSchedulingState.driversSelected.map(driver => ({
          ...pick(driver, ["id", "name", "srm_uid"])
        })) as Models.Driver[]
      };

      save(ticketSchedulingState);
    },
    get: userSettingsActions.get,
    Provider: userSettingsActions.Provider
  };
})();

export { TicketSchedulingSettings };
